import { FetchInvalidPayloadShapeError } from "@lib/errors";
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAuthenticationCredentialsIdUsages } from "./constants";
import type { AuthenticationCredentialUsagesResult } from "./types";
import { isAuthenticationCredentialUsagesResult } from "./validators";

export const getAuthenticationCredentialUsages = reactQueryFetcherAdapter(
  appSettingsAuthenticationCredentialsIdUsages,
  async (
    signal: AbortSignal,
    appGroupId: string,
    credentialId: string
  ): Promise<AuthenticationCredentialUsagesResult> => {
    const result: unknown = await fetch(
      `/app_settings/authentication_credentials/${encodeURIComponent(credentialId)}/usages`,
      "GET",
      { app_group_id: appGroupId },
      { signal },
      { propagateFetchRequestError: false }
    );
    // The shared adapter only logs invalid responses in production. Deletion must fail closed instead.
    if (!isAuthenticationCredentialUsagesResult(result)) {
      throw new FetchInvalidPayloadShapeError(appSettingsAuthenticationCredentialsIdUsages, result, []);
    }
    return result;
  },
  isAuthenticationCredentialUsagesResult
);
